import { Plugin } from '@ckeditor/ckeditor5-core';
import { ButtonView } from '@ckeditor/ckeditor5-ui';

import recordAudioIcon from './theme/icons/recordaudio.svg';
import recordVideoIcon from './theme/icons/recordvideo.svg';

export default class RecorderUI extends Plugin {
    static get pluginName() {
        return 'RecorderUI';
    }

    init() {
        const editor = this.editor;

        //  Botón de audio
        editor.ui.componentFactory.add('recordAudio', locale => {
            const view = new ButtonView(locale);
            view.set({
                label: 'Grabar audio',
                icon: recordAudioIcon,
                tooltip: true
            });

            this.listenTo(view, 'execute', () => {
                editor.execute('recordAudio');
                editor.editing.view.focus();
            });

            return view;
        });

        //  Botón de video
        editor.ui.componentFactory.add('recordVideo', locale => {
            const view = new ButtonView(locale);
            view.set({
                label: 'Grabar video',
                icon: recordVideoIcon,
                tooltip: true
            });

            this.listenTo(view, 'execute', () => {
                editor.execute('recordVideo');
                editor.editing.view.focus();
            });

            return view;
        });
    }
}
